export default "__VITE_ASSET__BWdijc0N__"